import React from 'react';
import {
  Snackbar,
  Alert,
  IconButton,
  Slide
} from '@mui/material';
import {
  Close as CloseIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Info as InfoIcon,
  Warning as WarningIcon
} from '@mui/icons-material';
const SlideTransition = (props) => {
  return <Slide {...props} direction="left" />;
};

const Toast = ({ toast, onClose }) => {

  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return <CheckCircleIcon sx={{ fontSize: 20 }} />;
      case 'error':
        return <ErrorIcon sx={{ fontSize: 20 }} />;
      case 'warning':
        return <WarningIcon sx={{ fontSize: 20 }} />;
      default:
        return <InfoIcon sx={{ fontSize: 20 }} />;
    }
  };

  const getSeverity = () => {
    switch (toast.type) {
      case 'success':
        return 'success';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      default:
        return 'info';
    }
  };

  return (
    <Snackbar
      open={true}
      autoHideDuration={toast.duration}
      onClose={() => onClose(toast.id)}
      TransitionComponent={SlideTransition}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{
        '& .MuiSnackbar-root': {
          top: 24,
          right: 24,
        }
      }}
    >
      <Alert
        severity={getSeverity()}
        icon={getIcon()}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => onClose(toast.id)}
            sx={{ ml: 1 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        sx={{
          minWidth: 300,
          '& .MuiAlert-message': {
            flex: 1,
          },
          '& .MuiAlert-action': {
            padding: 0,
            marginLeft: 1,
          }
        }}
      >
        {toast.message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
